var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAltArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09327 0.692224C1.35535 0.467585 1.74991 0.497936 1.97455 0.760015L6.97455 6.59335C7.17517 6.8274 7.17517 7.17278 6.97455 7.40684L1.97455 13.2402C1.74991 13.5023 1.35535 13.5326 1.09327 13.308C0.831188 13.0833 0.800837 12.6888 1.02548 12.4267L5.67684 7.00009L1.02548 1.5735C0.800837 1.31143 0.831188 0.916863 1.09327 0.692224Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltArrowRightIcon);
export default __webpack_public_path__ + "static/media/AltArrowRightIcon.2a039f1ffc5e2b6721459446fa50b54e.svg";
export { ForwardRef as ReactComponent };